
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2023
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Project Gemini',
	'appExit': 'Naar de welkomstpagina',


	'widgetsListLabel': 'Widgetlijst. Selecteer een widget en druk op enter om deze toe te voegen.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Up-to-date',
	'dirty': 'Niet up-to-date',
	'conflict': 'Conflict bij opslaan van view',
	'error': 'Probleem bij opslaan van view',
	'failure': 'Kan geen contact leggen met de server.',
	'saveFailed': 'Fout bij opslaan van de view',

	'wa_insync': 'Opgeslagen',
	'wa_conflict': 'Conflict bij opslaan van view',
	'wa_error': 'Fout bij opslaan van de view',
	'wa_failure': 'Kan geen contact leggen met de server.',

	// Menu Labels
	'changeDisplay': 'Weergave wijzigen',
	'changeToColumnChart': 'Wijzigen in kolomdiagram',
	'changeToBubbleChart': 'Wijzigen in bellendiagram',
	'toggleMoveHandles': 'Verplaatsingshandles afwisselen',
	'undo': 'Ongedaan maken',
	'redo': 'Opnieuw uitvoeren',
	'mode': 'Modus wijzigen',

	'untitled': 'Naamloos',
	'remove': 'Verwijderen',
	'editTitle': 'De titel bewerken',
	'edit': 'Bewerken',
	'done': 'Gereed',

	// Data tray
	'dataTrayHandleOpenLabel': 'Gegevenslade openen',
	'dataTrayHandleCloseLabel': 'Gegevenslade sluiten',

	// Dialogs
	'dlg_loading': 'Bezig met laden...',
	'dlg_ok': 'OK',
	'dlg_create': 'Maken',
	'dlg_cancel': 'Annuleren',
	'dlg_close': 'Sluiten',
	'dlg_update': 'Bijwerken',
	'dlg_renameBoardTitle': 'Dit object hernoemen',
	'dlg_renameDatasetTitle': 'Deze gegevensset hernoemen',
	'dlg_renameSceneTitle': 'Deze scène hernoemen',
	'dlg_NameLabel': 'Naam:',
	'dlg_NewNameLabel': 'Nieuwe naam:',
	'dlg_DefaultNameWithDataSet': '%{name}-view',
	'dlg_ShareTitle': 'Inhoud delen',
	'dlg_UnshareTitle': 'Het delen van inhoud verwijderen',
	'dlg_ShareUser': 'Gebruikersnaam:',
	'dlg_NewColumnLabel': 'Nieuwe berekeningsnaam',

	'dlg_new': 'Nieuw...',
	'dlg_open': 'Openen...',
	'dlg_makeACopy': 'Een kopie maken',
	'dlg_rename': 'Naam wijzigen...',
	'dlg_moreToCome': 'Meer acties volgen...',

	'dlg_use': 'Gebruiken',

	'dlg_RelinkDatasetTitle': 'Gegevensset \'%{datasetName}\' vervangen door ...',

	'open_error': 'Een probleem is opgetreden tijdens het openen van de view.',

	// Delete Board
	'del_dialogTitle': 'Wissen bevestigen',
	'del_itemMsg': 'Weet u zeker dat u \'%{name}\' wilt wissen?',
	'del_itemsMsg': 'Weet u zeker dat u %{count} items wilt wissen?',
	'del_deleteErr': '\'%{name}\' kan niet gewist worden',

	// List Sorting
	'dlg_ascending': 'oplopend',
	'dlg_descending': 'aflopend',
	'dlg_custom': 'aangepast',
	'dlg_none': 'geen',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Zoeken',

	'searchHint': 'Al uw gegevens doorzoeken',
	'clearSearchResult': 'Zoekresultaten wissen',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Cirkel',
	'shapesHexagon': 'Zeshoek',
	'shapesLine': 'Lijn',
	'shapesOctagon': 'Achthoek',
	'shapesPentagon': 'Vijfhoek',
	'shapesSquare': 'Vierkant',
	'shapesTriangle': 'Driehoek',
	'shapesDiamond': 'Ruit',
	'shapesTitle': 'Eigenschappen vorm', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Afgerond vierkant',
	'shapesStar': 'Ster',
	'shapesChevron': 'Chevron',
	'shapesBadge_ribbon': 'Badgelint',
	'shapesBadge': 'Badge',
	'shapesHeart': 'Hart',
	'shapesExclamation': 'Uitroepteken',
	'shapesTrendingup': 'Trend omhoog',
	'shapesTrendingdown': 'Trend omlaag',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Personen',
	'shapesFemale': 'Vrouwelijk',
	'shapesHappyface': 'Blij gezicht',
	'shapesMale': 'Mannelijk',
	'shapesMan': 'Man',
	'shapesNeutralface': 'Neutraal gezicht',
	'shapesSadface': 'Droevig gezicht',
	'shapesShakehands': 'Handen schudden',
	'shapesThumbsdown': 'Duim omlaag',
	'shapesThumbsup': 'Duim omhoog',
	'shapesWoman': 'Vrouw',

	// Weather and places
	'shapesPlacesWeatherCat': 'Plaatsen & weer',
	'shapesCity': 'Plaats',
	'shapesCloud': 'Wolk',
	'shapesEducation': 'Onderwijs',
	'shapesGovernment': 'Overheid',
	'shapesHalfcloud': 'Halve wolk',
	'shapesHouse': 'Huis',
	'shapesMoon': 'Maan',
	'shapesRain': 'Regen',
	'shapesSunny': 'Zonnig',

	//Vehicles
	'shapesVehiclesCat': 'Voertuigen',
	'shapesAirplane': 'Vliegtuig',
	'shapesCar': 'Auto',
	'shapesShip': 'Schip',
	'shapesShoppingcart': 'Winkelwagentje',
	'shapesTrain': 'Trein',
	'shapesTruck': 'Vrachtauto',

	//Objects
	'shapesObjectsCat': 'Objecten',
	'shapesBook': 'Boek',
	'shapesBriefcase': 'Tas',
	'shapesCalendar': 'Kalender',
	'shapesCheck': 'Vinkje',
	'shapesClock': 'Klok',
	'shapesDesktop': 'Bureaublad',
	'shapesDocument': 'Document',

	'shapesFood': 'Etenswaren',
	'shapesGear': 'Versnelling',
	'shapesHealth': 'Gezondheid',

	'shapesIdea': 'Idee',
	'shapesMobile': 'Mobiel',
	'shapesMoney_bill': 'Geldbiljet',
	'shapesMoney_coin': 'Muntgeld',
	'shapesPiggybank': 'Spaarvarken',
	'shapesStackofpaper': 'Stapel papier',
	'shapesStickynote1': 'Notitievel 1',
	'shapesStickynote2': 'Notitievel 2',
	'shapesTarget': 'Doel',
	'shapesTool': 'Gereedschap',

	'shapesUmbrella': 'Paraplu',

	'shapesBrain': 'Hersenen',
	'shapesSkull': 'Schedel',
	'shapesEye': 'Oog',

	// Arrows shapes
	'shapesArrowsCat': 'Pijlen',
	'shapesRightArrow': 'Pijl naar rechts',
	'shapesLeftArrow': 'Pijl naar links',
	'shapesDoubleArrow': 'Dubbele pijl',
	'shapesCurvedArrow': 'Kromme pijl',

	// Callouts shapes
	'shapesCalloutsCat': 'Toelichtingen',
	'shapesRectCallout': 'Toelichting',

	// Images
	'imagesCat': 'Afbeeldingen',
	'imageWidgetTitle': 'Afbeeldingswidget',
	'imgUrl': 'Afbeeldings-URL',
	'noImgSelected': 'Geen afbeelding geselecteerd',
	'enterImgUrl': 'Geef hier de URL van de afbeelding op',
	'imgPasteLink': 'Plak de URL en druk op Enter om deze op te slaan.',
	'imgResizeToFit': 'Formaat aanpassen aan grootte van afbeelding',
	'imgHeight': 'Hoogte:',
	'imgWidth': 'Breedte:',
	'imgTransparency': 'Transparantie:',
	'imgMissingUrl': 'De afbeeldings-URL ontbreekt.',
	'imgUrlValidationError': 'De afbeeldings-URL is ongeldig.',
	'imgUrlInvalidDomainError': 'De afbeeldings-URL verwijst naar een domein dat niet is goedgekeurd door uw beheerder. De domeinen die door uw beheerder zijn goedgekeurd, zijn "%{domains}".',
	'notPositiveNumberError': 'Alleen positieve waarden',

	// line shape
	'propStrokeWidth': 'Lijndikte',
	'propStrokeDashArray': 'Lijnstijl',
	'propStrokeSolidline': 'Ononderbroken lijn',
	'propStrokeLineCap': 'Lijneinde',
	'propStrokeLineCapButt': 'Doorloop',
	'propStrokeLineCapRound': 'Rond',
	'propStrokeLineCapSquare': 'Vierkant',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Afspelen',
	'dataPlayerValueListLabel': 'Waarden voor gegevensspeler',
	// Text Widget
	'textWidgetTitle': 'Tekstwidget',
	'textStyle': 'Stijlen',
	'textStyleDescription': 'Vooraf ingedeelde tekststijlen',
	'textTitleStyle': 'Titel',
	'textTitleSmallStyle': 'Kleine titel',
	'textSubtitleStyle': 'Onderschrift',
	'textBodyStyle': 'Tekst',
	'textBodySmallStyle': 'Kleine tekst',
	'textCaptionStyle': 'Bijschrift',
	'textQuoteStyle': 'Aanhaling',
	'textQuoteSmallStyle': 'Kleine aanhaling',
	'textResponsiveStyle': 'Formaat automatisch wijzigen',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Haarlijn',
	'textFontFamilySubClassThin': 'Dun',
	'textFontFamilySubClassThinItalic': 'Dun cursief',
	'textFontFamilySubClassExtraLight': 'Extra licht',
	'textFontFamilySubClassExtraLightItalic': 'Extra licht cursief',
	'textFontFamilySubClassLight': 'Licht',
	'textFontFamilySubClassLightItalic': 'Licht cursief',
	'textFontFamilySubClassRegular': 'Normaal',
	'textFontFamilySubClassRegularItalic': 'Normaal cursief',
	'textFontFamilySubClassItalic': 'Cursief',
	'textFontFamilySubClassMedium': 'Medium',
	'textFontFamilySubClassMediumItalic': 'Medium cursief',
	'textFontFamilySubClassHeavy': 'Zwaar',
	'textFontFamilySubClassHeavyItalic': 'Zwaar cursief',
	'textFontFamilySubClassDemiBold': 'Half vet',
	'textFontFamilySubClassDemiBoldItalic': 'Half vet cursief',
	'textFontFamilySubClassBold': 'Vet',
	'textFontFamilySubClassBoldItalic': 'Vet cursief',
	'textFontFamilySubClassExtraBold': 'Extra vet',
	'textFontFamilySubClassExtraBoldItalic': 'Extra vet cursief',
	'textFontFamilySubClassBlack': 'Zwart',
	'textFontFamilySubClassBlackItalic': 'Zwart cursief',
	'textFontFamilySubClassStencil': 'Stencil',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Grootte lettertype automatisch wijzigen',
	'responsiveCoachmarkContents': 'De lettergrootte verandert automatisch naar passend als u de grootte van dit type tekst wijzigt. U kunt de lettergrootte in de teksteigenschappen instellen.',

	'propText': 'Tekstgegevens', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Teksteigenschappen', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Lettergrootte',
	'textFontFamily': 'Letterfamilie',
	'textFontWeight': 'Gewicht van lettertype', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'textFontColor': 'Kleur',
	'textLineHeight': 'Regelhoogte',
	'textIndentation': 'Inspringing',
	'textIncreaseIndentation': 'Inspringing vergroten',
	'textDecreaseIndentation': 'Inspringing verkleinen',
	'textInnerMargins': 'Binnenste marges (px)',

	// Widget Properties
	'propImageLink': 'Afbeeldingslink',
	'propMissingURL': 'Voer de URL in',
	'propImgTop': 'Eigenschappen van afbeelding', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'Algemene eigenschappen', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'Algemeen', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'Algemeen', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Opvulkleur', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Tekstkleur', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Kaderkleur',
	'propBorderRadius': 'Hoekstraal (px)',
	'propShowBorderInPreview': 'Geselecteerde rand afbeelden in preview',
	'propMaintainAxisScales': 'Asschaal handhaven',
	'propShowItemLabel': 'Itemlabel afbeelden',
	'propHideLegend': 'Legenda verbergen',
	'propColorPalette': 'Palet',
	'propLegendPosition': 'Positie van legenda',
	'propHideAxisTitleLabels': 'Astitels verbergen',
	'propLineColor': 'Lijnkleur',
	'propBubbleColor': 'Kleur van bel',
	'propInterpolation': 'Vloeiende lijnen',
	'propElementColor': 'Kleur visualisatie-element',
	'propSymbolShape': 'Symboolvorm',
	'propHeatScalePalette': 'Kleurvolgorde',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Donkerder kleuren vertegenwoordigen kleinere waarden.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Donkerder kleuren vertegenwoordigen grotere waarden.',
	'propImageDetails': 'Afbeeldingsgegevens', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Gegevens webpagina', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Mediagegevens', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'Voer de URL in en druk op Enter.',

	//Layout Properties
	'sectionName_positionAndStyle': 'Positie & stijl',
	'propPositionLabel': 'Positie', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis_v1': 'X',
	'propPositionXAxis': 'X-positie (%{unit})',
	'propPositionYAxis_v1': 'Y',
	'propPositionYAxis': 'Y-positie (%{unit})',
	'propResizeLabel': 'Grootte', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth_v1': 'Breedte',
	'propResizeWidth': 'Breedte (%{unit})',
	'propResizeHeight_v1': 'Hoogte',
	'propResizeHeight': 'Hoogte (%{unit})',
	'propRotateLabel_v1': 'Draaien',
	'propRotateLabel': 'Draaien (°)',
	'propRotateAngle': 'Hoek', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Aantal pictogrammen',
	'propScaleDescription': 'Selecteer het aantal pictogrammen',
	'propScaleFew': 'Laagste',
	'propScaleDefault': 'Standaardwaarde',
	'propScaleMany': 'Hoogste',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'Deze waarde moet numeriek zijn',

	'mediaAriaLabel': 'URL-invoer',
	'dropdownAriaLabel' : 'Vervolgkeuzelijst',
	'ariaGroupLabel': 'Categorie van vervolgkeuzelijst: %{cateoryLabel}-item: %{itemLabel}. Druk op OMLAAG om uit te vouwen. Druk op de toetsen OMHOOG en OMLAAG om te navigeren of druk op ESCAPE om samen te vouwen.',
	'colorNoFillLabel': 'Geen vulling',
	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Laatste vernieuwing: %{timeInterval} geleden',
	'widgetTimer': 'Widgettimer',

	// Theme colors
	'transparent': 'Geen kleur',
	'white': 'Wit',
	'lightGrey': 'Lichtgrijs',
	'grey': 'Grijs',
	'darkGrey': 'Donkergrijs',
	'black': 'Zwart',
	'lightBlue': 'Lichtblauw',
	'blue': 'Blauw',
	'darkBlue': 'Donkerblauw',
	'yellow': 'Geel',
	'orange': 'Oranje',
	'lime': 'Lichtgroen',
	'green': 'Groen',
	'peach': 'Perzik',
	'red': 'Rood',
	'violet': 'Violet',
	'aqua': 'Zeeblauw',
	'purple': 'Paars',
	'plum': 'Donkerrood',
	'gray10': 'Grijs 10',
	'gray20': 'Grijs 20',
	'gray30': 'Grijs 30',
	'gray50': 'Grijs 50',
	'gray60': 'Grijs 60',
	'gray70': 'Grijs 70',
	'gray80': 'Grijs 80',
	'gray90': 'Grijs 90',
	'gray100': 'Grijs 100',
	'blue50': 'Blauw 50',
	'blue60': 'Blauw 60',
	'blue70': 'Blauw 70',
	'green40': 'Groen 40',
	'green50': 'Groen 50',
	'red50': 'Rood 50',
	'red60': 'Rood 60',


	//Theme Palette Labels
	'themeLabel': 'Thema',
	'paletteLabel': 'IBM-palet %{number}',
	'heatPaletteLabel': 'IBM-heatpalet %{number}',
	'conditionalPaletteLabel': 'IBM voorwaardelijk palet%{number}',
	'carbonPaletteXLight': 'Carbon X licht',
	'carbonPaletteXDark': 'Carbon X donker',
	'carbonPalettePurple': 'Paars',
	'carbonPaletteTeal': 'Groenblauw',
	'carbonPaletteCyan': 'Cyaan',
	'carbonPaletteMagenta': 'Magenta',
	'carbonPalettePurpleTeal': 'Paars Groenblauw',
	'carbonPaletteCyanMagenta': 'Cyaan Magenta',
	'carbonPaletteGreenRed': 'Groen Rood',
	'carbonPaletteGreenYellowRed': 'Groen Geel Rood',
	'carbonPalettePurpleTealConvergent': 'Paars Groenblauw Convergent',
	'carbonPaletteCyanMagentaConvergent': 'Cyaan Magenta Convergent',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'IBM licht palet',
	'userPaletteColor_defaultTheme': 'IBM standaardpalet',
	'userPaletteColor_darkTheme': 'IBM donker palet',

	// Dashboard
	'propDashboardBackgroundColor': 'Achtergrondkleur',
	'propLayoutPositioning': 'Layoutpositionering',
	'propLayoutRelative': 'Relatief',
	'propLayoutAbsolute': 'Absoluut',
	'propLayoutPositioningCoachmarkTitle': 'Selecteer een layoutstijl',
	'propLayoutPositioningCoachmarkContent': 'In een relatieve layout worden de grootte en positie van de widgets aangepast, zodat de widgets in het scherm passen. In een absolute layout worden de widgets exact volgens de door u opgegeven grootte en positie weergegeven, ongeacht de grootte van het scherm.',
	'gridText': 'Raster afbeelden',
	'snapText': 'Naar raster springen',
	'snapObjectsText': 'Naar objecten springen',
	'fitPageText': 'Passend maken aan pagina',
	'gridLabel': 'Raster',
	'heightUnit': 'h',
	'widthUnit': 'b',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Paginagrootte',
	'propPageSizePresetAriaLabel': 'Vooraf ingestelde paginagrootte',
	'propPageSizePreset_v1': 'Vooraf ingesteld',
	'propPageSizePreset': 'Paginagrootte',
	'propPageSizePresetCustom': 'Aangepast',
	'propPageSizePreset16x9': 'Scherm 16:9',
	'propPageSizePreset4x3': 'Scherm 4:3',
	'propPageSizePresetInfographic': 'Infographic',
	'propPageSizeWidth_v1': 'Breedte',
	'propPageSizeWidth': 'Breedte (px)',
	'propPageSizeHeight_v1': 'Hoogte',
	'propPageSizeHeight': 'Hoogte (px)',
	'propPageSizeWidthAriaLabel': 'Paginabreedte',
	'propPageSizeHeightAriaLabel': 'Paginahoogte',
	'propPageSizeAdjustedMessage': 'De pagina is groter gemaakt, want de door u opgegeven waarde lag onder het minimum of uw dashboard zou niet gepast hebben.',
	'propTabShow': 'Tabs afbeelden',
	'propShowTabsInPreview': 'Tabbladen in preview afbeelden',
	'multilingualDashboardsLabel': 'Talen',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Standaard',
	'multilingualDashboardsAddLinkText': 'Andere taal toevoegen',
	'multilingualDashboardsSelect': 'Selecteren',
	'multilingualDashboardsButtonLabel': 'Toevoegen',
	'multilingualDashboardTranslationMode': 'U bent nu in de vertaalmodus (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Gereed',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} vertalingen resterend',
	'multilingualDashboardRemainingString': '1 vertaling resterend',
	'multilingualDashboardsSetDefault': 'Standaardtaal instellen',
	'multilingualDashboardIconMore': 'Meer acties voor taal %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Vertaalbaar gebied',
	'multilingualDeleteTitle': 'Taal wissen',
	'multilingualDeleteLanguageWarning': 'Weet u zeker dat u de taal \'%{language}\' wilt wissen?',
	'multilingualSelectLanguage': 'Selecteer een taal',
	'confirmLayoutStyleUpgradeTitle': 'Toepassen op alle tabs',
	'confirmLayoutStyleUpgrade': 'Wilt u dat deze layoutstijl wordt toegepast op alle tabs in uw dashboard?',
	'defaultBackgroundColorLabel': 'Standaard',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Verwijderen',
	'tabDeleteDialogTitle': 'Dit tabblad wissen?',
	'tabDeleteDialogMessage': 'Alle content op dit tabblad wordt eveneens gewist.',

	// Vis widget
	'propVisTypeReturn': 'Visualisatietypen',
	'propVisDetails': 'Details',

	// Alignment picker
	'propAlignPickTop': 'Boven uitlijnen',
	'propAlignPickRight': 'Rechts uitlijnen',
	'propAlignPickBottom': 'Onder uitlijnen',
	'propAlignPickLeft': 'Links uitlijnen',
	'propAlignPickCenter': 'Centreren',
	'propAlignPickMiddle': 'Midden uitlijnen',
	'propAlignPicker': 'Horizontale uitlijning',
	'propVerticalAlignPicker': 'Verticale uitlijning',

	// Toolbar picker
	'propToolbarPickBold': 'Vet',
	'propToolbarPickUnderline': 'Onderstrepen',
	'propToolbarPickItalic': 'Cursief',
	'propToolbarPickJustifyLeft': 'Links uitlijnen',
	'propToolbarPickJustifyCenter': 'Centreren',
	'propToolbarPickJustifyRight': 'Rechts uitlijnen',
	'propToolbarPickJustify': 'Uitvullen',

	'propList': 'Lijst',
	'propOrderedList': 'Geordende lijst',
	'propUnorderedList': 'Niet-geordende lijst',

	// Symbol shapes
	'propCircle': 'Cirkel',
	'propTriangle': 'Driehoek',
	'propSquare': 'Vierkant',
	'propRect': 'Rechthoek',
	'propStar': 'Ster',
	'propCross': 'Kruisend',
	'propPlus': 'Plus',
	'propPoly': 'Veelhoek',


	// True and false selection
	'propTrue': 'Waar',
	'propFalse': 'Onwaar',

	// Position selection
	'propLeft': 'Links',
	'propRight': 'Rechts',
	'propTop': 'Bovenaan',
	'propBottom': 'Onderaan',

	// Interpolation options
	'propSmooth': 'Vloeiend',
	'propStraight': 'Recht',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Lijst', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Naar links', // screen reader
	'srWidgetMoveUp': 'Omhoog verplaatsen', // screen reader
	'srWidgetMoveRight': 'Naar rechts', // screen reader
	'srWidgetMoveDown': 'Omlaag verplaatsen', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Grootte proportioneel doen toenemen', // screen reader
	'srWidgetResizeSmaller': 'Grootte proportioneel doen afnemen', // screen reader
	'srWidgetResizeBiggerV': 'Grootte verticaal doen toenemen', // screen reader
	'srWidgetResizeSmallerV': 'Grootte verticaal doen afnemen', // screen reader
	'srWidgetResizeBiggerH': 'Grootte horizontaal doen toenemen', // screen reader
	'srWidgetResizeSmallerH': 'Grootte horizontaal doen afnemen', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Rechtsom draaien', // screen reader
	'srWidgetRotateCCW': 'Linksom draaien', // screen reader

	// Recommended types
	'visChange': 'Visualisatie wijzigen',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Visualisatie',
	'chartLabel': '%{chartName}-diagram',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Druk op F12 om binnen de widget te navigeren.',
	'f10KeyDescription': 'Druk op F10 om de focusweergave van de widget te starten',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} met waarde %{value}',

	'shapeColorLabel': 'Vormkleur',
	'showLegendLabel': 'Legenda weergeven',

	//Webpage
	'webpageWidgetTitle': 'Widget voor webpagina',
	'webpagePasteLink': 'Plak de URL en druk op Enter om hem op te slaan.',
	'propWebpageLink': 'URL webpagina',
	'propWebpageTitle': 'Titel webpagina',
	'propWebpageTitleDescription': 'Titel van de webpagina',
	'webpageUrl': 'URL webpagina',
	'noWebpageSelected': 'Geen webpagina geselecteerd',
	'enterWebpageUrl': 'Geef hier de URL van de webpagina op',
	'propWebpageTop': 'Eigenschappen webpagina', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'De URL van de webpagina ontbreekt.',
	'webpageUrlValidationError': 'De URL van de webpagina is ongeldig.',
	'webpageHttpValidationError': 'De webpagina moet worden geopend met behulp van een HTTPS-link.',
	'webpageInvalidDomainError': 'De URL van de webpagina verwijst naar een domein dat niet is goedgekeurd door uw beheerder. De domeinen die door uw beheerder zijn goedgekeurd, zijn "%{domains}".',

	//VizState
	'vzErrorLoading': 'De visualisatie kan niet worden geladen',
	'vzErrorLoadingMissingData': 'De visualisatie kan niet worden geladen, vanwege ontbrekende contextgegevens',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Mediawidget',
	'mediaPasteLink': 'Plak de URL en druk op Enter om hem op te slaan.',
	'mediaUrl': 'Media-URL',
	'noMediaSelected': 'Geen media geselecteerd',
	'enterMediaUrl': 'Geef hier de media-URL op',
	'videoHeight': 'Hoogte:',
	'videoWidth': 'Breedte:',
	'propMediaLink': 'Medialink',
	'propMediaTitle': 'Mediatitel',
	'propMediaTitleDescription': 'Titel van het opslagmedium',
	'propMediaTop': 'Media-eigenschappen', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'De URL van de medialink ontbreekt.',
	'mediaUrlValidationError': 'De URL van het mediabestand is ongeldig.',
	'mediaUnknownValidationError': 'Dit type media wordt niet ondersteund.',
	'mediaHttpValidationError': 'Het mediabestand moet worden geopend met behulp van een HTTPS-link.',
	'mediaInvalidDomainError': 'De URL van het mediabestand verwijst naar een domein dat niet is goedgekeurd door uw beheerder. De domeinen die door uw beheerder zijn goedgekeurd, zijn "%{domains}".',

	// Properties pane
	'commonPropertiesLabel': 'Eigenschappen', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Gegevensset',
	'dataViewsLabel': 'Beeld',
	'columnQuality': 'Gegevenskwaliteit',
	'columnProperties': 'Gegevenseigenschappen',

	'dataQuality': 'Gegevenskwaliteit',
	'dataQualityRowCount': 'Aantal rijen',
	'dataQualityDistribution': 'Distributie',
	'dataRowLabel': 'Gegevens',

	// Modelling UI
	'typeColumn': 'Typen',
	'modellingColumnType': 'Typen',
	'modellingColumnAggregation': 'Aggregatie',
	'modellingColumnUsage': 'Gebruik',
	'modellingColumnSort': 'Sorteren',
	'modellingColumnFormat': 'Indeling',
	'modellingColumnCategory': 'Categorie',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Bezig met laden...',

	'modellingProcessing': 'Verwerken...',
	'modellingImport': 'Importeren',
	'modellingReimport': 'Opnieuw importeren',
	'modellingDatasourceTitle': 'Gegevensbron',
	'modellingImportStartedTitle': 'Importeren is gestart',
	'modellingImportStartedText': 'Het importeren van uw gegevens kan even duren.\n\n(U kunt een view maken terwijl de gegevens worden geïmporteerd.)',
	'importDatasourceTitle': 'Verbindingen',
	'dropHere': 'Zet hier neer om een nieuwe gegevensbron te maken...',
	'browseButton': 'Bladeren',
	'errorNoData': 'Er zijn geen gegevens om te verwerken.',
	'errorNoFile': 'Er is geen bestand om te uploaden.',
	'errorUploadFailed': 'Kan niet uploaden.',
	'uploadSucceessful': 'Uploaden is geslaagd',
	'del_datasourceTitle': 'Gegevensset wissen',
	'del_datasourceMsg': 'Weet u zeker dat u \'%{name}\' wilt wissen?',
	'modellingFileUpdate': 'Bijwerken',
	'modellingFileUpdateTitle': 'Gegevensset bijwerken',
	'modellingFileUpdateDescription': 'Wilt u \'%{name}\' bijwerken?',
	'modellingFileUpdatingTitle': '\'%{name}\' bijwerken',
	'modellingUpdateStartedTitle': 'Bijwerken van import is gestart',
	'modellingUpdateStartedText': 'Het bijwerken van uw gegevens kan even duren.\n\n(U kunt een view maken terwijl de gegevens worden bijgewerkt.)',
	'modellingErrorImportUploadNoFile': 'Geen bestand om te uploaden.',
	'modellingErrorImportUploadFailed': 'Kan niet uploaden.',
	'modellingErrorImportUploadInvalidType': 'Het bestandstype is ongeldig.',
	'modellingErrorImportUploadTableFailed': 'Kan tabellen niet ophalen',
	'modellingIntentResultsTitle': 'Selecteer de te gebruiken voorgestelde gegevensset',
	'modellingColumnViewRelationships': 'Gerelateerde tabellen bekijken',
	'modellingTableRelatedTables': 'Tabellen met betrekking tot \'%{name}\'',
	'modellingTable': '%{name} - Tabel',
	'modellingColumnIncludedInDataSet': 'Toegevoegd',
	'modellingDataSet': 'Gegevensset',
	'modellingViewInDataSet': 'Weergeven in gegevensset',
	'modellingViewRelatedTables': 'Gerelateerde bekijken',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Geen gerelateerde tabellen gevonden',

	'modellingValidatingDataset': 'Bezig met valideren...',
	'datasetFinishedRefreshing': 'Gegevensset %{datasetName} is vernieuwd.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Join-pad omzetten:',
	'modellingJoinColumns': 'Definieer een join-pad voor tabel: %{name}',
	'modellingJoinToTable': 'Join maken met tabel: %{name}',

	// Data Quality
	'excluded': 'Uitgesloten',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'D',
	'metricPrefixQuadrillion': 'K',

	//Column Flyout
	'modellingColumnFilter': 'Filteren',
	'modellingColumnSortNone': 'De sortering wissen',
	'modellingColumnSortAsc': 'Oplopend sorteren',
	'modellingColumnSortDesc': 'Aflopend sorteren',
	'modellingColumnRemove': 'Deze kolom verwijderen',

	// Import File Browser
	'dropboxPageTitle': 'Nieuwe dropbox-verbinding',
	'sizeColumn': 'Grootte',

	//Modelling Column Property Values
	'dataType_string': 'Tekenreeks',
	'dataType_date': 'Date',
	'dataType_integer': 'Geheel getal',
	'dataType_double': 'Dubbel',
	'dataType_float': 'Zweven',
	'dataType_boolean': 'Booleaans',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Aantal',
	'defaultAggregation_countdistinct': 'Afzonderlijk tellen',
	'defaultAggregation_max': 'Maximum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Gemiddeld',
	'defaultAggregation_sum': 'Som',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',

	'type_fact': 'Feit',
	'type_attribute': 'Kenmerk',

	'defaultSort_none': 'Niet sorteren',
	'defaultSort_asc': 'Oplopend sorteren',
	'defaultSort_desc': 'Aflopend sorteren',

	'category_none': 'Geen',
	'category_location': 'Locatie',
	'category_monetary': 'Monetair',
	'category_time': 'Tijd',

	// Root menu
	'rootMenuTitle': 'Hoofdmenu',

	'errorMessageTitle': 'Fout',
	'errorMessageDetails': 'Details: ',
	'errorMessageTitleAssetAlreadyExists': 'Activum bestaat al',

	'defaultTabTitle': 'Tab %{index}',
	'tabAddBtnTitle': 'Nieuwe tab toevoegen',
	'defaultInfographicTitle': 'Infographic',

	'unsupportedConditionalFormattingEncountered': 'Voorwaardelijke opmaak wordt niet meer op een aantal kolommen toegepast. ',


	// Homepage View
	'nameColumn': 'Naam',
	'creatorColumn': 'Gemaakt door',
	'creationDateColumn': 'Gemaakt op',
	'versionColumn': 'Versie',
	'modifiedColumn': 'Laatst gewijzigd',

	'filterBy': 'Items filteren',
	'allFilter': 'Alle items',
	'createdByMeFilter': 'Door mij gemaakt',
	'sharedWithMeFilter': 'Met mij gedeeld',
	'favoritesFilter': 'Mijn favorieten',
	'recentsFilter': 'Recent toegevoegd',
	'sortBy': 'Sorteren op',

	// Sort Menu
	'sortModified': 'Gewijzigd',
	'sortUpdated': 'Bijgewerkt',
	'sortName': 'Naam',

	'viewAs': 'Weergeven als',
	'thumbnailsView': 'Weergeven als miniaturen',
	'listView': 'Weergeven als een lijst',
	'createMenu': 'Maken',
	'newAppItem': 'Dashboard',
	'newDataSet': 'Gegevensset',

	'menuSelectionState_a11y': '"%{item}"-selector is ingesteld op "%{selectedItem}"',

	'unableToShareItem': 'Item "%{item}" kan niet worden gedeeld.',
	'toastFetchingContent': 'Bezig met ophalen van meer inhoud...',
	'unableToGetData': 'Kan inhoud niet ophalen.',
	'unableToFavorite': 'De status van de favoriet kan niet worden gewijzigd.',
	'hpErrorMissingRequiredOptions': 'Vereiste initialisatieopties ontbreken',
	'unableToOpenBoard': '"%{name}" kan niet worden geopend.',
	'unableToDuplicateBoard': '"%{name}" kan niet gedupliceerd worden.',
	'unableToCreateBoard': '"%{name}" kan niet worden gemaakt.',
	'unableToCreateBoardNameConflict': 'Er is al een activum met deze naam.',

	// DataSet Detail View
	'status': 'Status',
	'numberOfRows': 'Rijen',
	'importWarnings': 'Waarschuwingen',
	'lineNumbers': 'Regels',
	'excerptFromSource': 'Fragment',
	'reason': 'Reden',
	'numberOfRowsDropped': 'rijen verwijderd',
	'oneRowDropped': '1 rij is verwijderd',

	// Type Menu
	'typeMenuLabel': 'Typen',
	'dashboardsLabel': 'Dashboards',
	'datasetsLabel': 'Gegevenssets',
	'storiesLabel': 'Story\'s',
	'allLabel': 'Alle typen',

	// Board Page View App Bar
	'datasets': 'Gegevenssets',
	'settings': 'Eigenschappen',
	'add': 'Toevoegen',
	'widgets': 'Widgets',
	'dashboardProperties': 'Dashboardeigenschappen',
	'searchPanel' : 'Zoeken',
	'pins': 'Verzameling',
	'pinsOld': 'Mijn vastgezette items',
	'pinsDateFilterHeading' : 'Datum vastgezet',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} vastgezet item |||| %{smart_count} vastgezette items',
	'pinSearch': 'Zoeken',
	'pinSearchOld': 'Zoeken naar vastzettingen',
	'pinListView': 'Lijstview',
	'pinIconView': 'Pictogramweergave',
	'pinRemove': 'Verwijderen',
	'pinCreate': 'Maken',
	'pinDeleteError': 'Een of meer activa kunnen niet worden gewist in de verzameling. Probeer het later opnieuw.',
	'pinDeleteErrorOld': 'Een of meer vastzettingen kunnen niet worden gewist. Probeer het later opnieuw.',
	'pinRetrieveError': 'Een of meer vastzettingen kunnen niet worden opgehaald. Probeer het later opnieuw.',
	'NoPinsCollected': 'Geen vastgezette visualisaties',
	'pinDeletedToast': 'Vastgezet item is verwijderd',
	'pinRenamedToast': 'Naam van pin is gewijzigd',
	'pinAddedToast': 'Vastgezet item is toegevoegd aan Mijn vastgezette items',
	'pinningToast': 'Vastgezet item wordt verwerkt...',
	'pinDateFilter': 'Datumfilter',
	'pinDateFilterAll': 'Alle',
	'pinDateFilterToday': 'Vandaag',
	'pinDateFilterYesterday': 'Gisteren',
	'pinDateFilterPastWeek': 'Vorige week',
	'pinDateFilterPastMonth': 'Vorige maand',
	'pinDateFilterEarlier': 'Eerder',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Titel bewerken',
	'toolbarActionSort': 'Sorteren',
	'toolbarActionSortAscending': 'Oplopend sorteren',
	'toolbarActionSortDescending': 'Aflopend sorteren',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionFormat': 'Gegevens indelen',
	'toolbarActionFormatAbbreviation': 'Afkorten',
	'toolbarActionFormatNone': 'Automatisch',
	'toolbarActionFilter': 'Filteren',
	'toolbarActionTopBottom': 'Bovenste of onderste',
	'toolbarActionAddShape': 'Vorm toevoegen',
	'toolbarActionRmvShape': 'Vorm verwijderen',
	'toolbarActionToggleShapeDrop': 'Vorm van infographic',
	'toolbarActionToggleShapeDropTitle': 'Een infographic maken',
	'toolbarActionToggleShapeDropText': 'Maak een infographic door een vorm naar dit veld te slepen.',
	'toolbarActionAggregationType': 'Samenvatten',
	'toolbarDeleteActionText': 'Kolom verwijderen',
	'toolbarActionFilterLocalKeepSelected': 'Behouden',
	'toolbarActionFilterLocalExcludeSelected': 'Uitsluiten',
	'toolbarActionFilterAllKeepSelected': 'Filteren',
	'toolbarActionSimpleCalculation': 'Eenvoudige berekening',
	'toolbarActionDrillBack': 'Terug',
	'toolbarActionDrillUp': 'Omhoog drillen',
	'toolbarActionDrillDown': 'Inzoomen',
	'toolbarActionNavigate': 'Navigeren',
	'toolbarActionCreateFilterGroup': 'Nieuwe verbinding maken',
	'toolbarActionDisconnectFilterGroup': 'Alle verbindingen verbreken',
	'toolbarActionLinkFilterGroup': 'Toevoegen aan een bestaande verbinding',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Toevoegen',
	'sidebarMultiselect': 'Meervoudige selectie afwisselen',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} geselecteerd',

	'multiselectWithTotalMsg': '%{count} van %{total}',
	'sidebarGoBack': 'Teruggaan',

	//DataSet pane
	'errorLoadingDataSets': 'We kunnen deze gegevensset niet laden',
	'errorLoadingDataSetMetaData': 'We kunnen deze gegevensset niet laden',
	'dataSetPaneLastUpdated': 'Laatst bijgewerkt: %{date}',
	'dataSetPaneDateUnknown': 'Onbekend',
	'sourcePaneLabel': 'Geselecteerde bronnen',
	'addSourceLabel': 'Een bron toevoegen',
	'find_label': 'Zoeken',
	'navigationPathsLabel': 'Navigatiepaden',

	//widgetlist
	'errorLoadingWidgetList': 'We kunnen de objecten niet laden',
	'errorLoadingThemeFile': 'We kunnen de themadefinitie niet laden',
	'errorLoadingLayoutFile': 'We kunnen de view niet laden',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'We kunnen de beschikbare visualisatiedefinities niet laden',

	'dwErrorLoadingVisualizationNotFound': 'We kunnen het object niet laden, omdat er een visualisatiedefinitie in ontbreekt',
	'dwErrorLoadingVisualizationListNotFound': 'We kunnen de visualisatie niet laden',
	'dwErrorRunningQuery': 'De gegevens kunnen niet worden opgehaald uit gegevensset %{datasetName}.',
	'dwErrorGeoData': 'Er zijn problemen met het afbeelden van geografische gegevens op een kaart. Kies een ander type visualisatie. ',
	'dwPromptSignonCancelWarning': 'De gegevens voor deze visualisatie zijn niet beschikbaar. Geef de juiste legitimatiegegevens op.',
	'dwErrorMissingDataset': 'De visualisatie kan niet worden geladen omdat de bijbehorende gegevensset \'%{datasetName}\' niet beschikbaar is.',
	'dwErrorRenderingVisualization': 'We kunnen deze visualisatie niet laden',
	'dwErrorVisualizationTooSmall': 'De visualisatie is te klein voor het afbeelden van de daarin aanwezige gegevens. Maak de visualisatie groter of verminder het aantal gegevens.',
	'aria_label_datatable': 'Gegevenstabel',
	'aria_key_navi_datatable_desc': 'Met de cursortoetsen kunt u naar elke cel navigeren. Druk op de toetsen Ctrl + Home om naar de eerste rij te gaan, Ctrl + End om naar de laatste rij te gaan.',
	'geomapUnrecognizedLocations': 'Niet-herkende locaties:',
	'geomapAmbiguousLocations': 'Ambigue regio\'s:',

	// custom widget
	'customWidget': 'Aangepaste widget',
	'customWidgetsTitle': 'Aangepaste widgets',
	'noCustomWidgets': 'Geen aangepaste widgets',

	// Action names
	'toggleContextBar': 'Contextbalk afwisselend activeren',
	'delete': 'Verwijderen',
	'share': 'Delen',
	'unshare': 'Stoppen met delen',
	'rename': 'Naam wijzigen',
	'close': 'Sluiten',
	'duplicate': 'Dupliceren',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Probeer opnieuw',

	'changeTemplate': 'Sjabloon wijzigen',

	// Aggregation Types
	'sum': 'Som',
	'count': 'Aantal',
	'countdistinct': 'Afzonderlijk tellen',
	'avg': 'Gemiddeld',
	'min': 'Minimum',
	'max': 'Maximum',
	'custom': 'Aangepast',
	'calculated': 'Berekend',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% wijziging',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Visualisatiecriteria...',
	'QuickAddResultsHeader': 'Gegevensvisualisaties',
	'NoQuickAddResults': 'Er is niets dat overeenkomt met uw bedoeling. Nieuwe gegevensset maken?',
	'NoQuickAddResultsRetry': 'We kunnen geen overeenkomsten vinden. Probeer het opnieuw met andere zoektermen.',
	'templateWidgetTitle': 'Sjabloon',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(blanco)',

	'nullValueContent': '(geen waarde)',
	'nullValueText': 'Null',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Tekstfilter - %{columnName}',

	'textFilterSelectTab': 'Selecteren',

	'textFilterConditionTab': 'Voorwaarde instellen',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Er zijn geen items beschikbaar.',

	'textFilterEquals': 'Gelijk aan',
	'textFilterContains': 'Bevat',
	'textFilterBeginsWith': 'Begint met',
	'textFilterEndsWith': 'Eindigt op',
	'textFilterDoesNotEqual': 'Is niet gelijk aan',
	'textFilterDoesNotContain': 'Bevat niet',
	'textFilterDoesNotBeginWith': 'Begint niet met',
	'textFilterDoesNotEndWith': 'Eindigt niet op',
	'textFilterSampleText': 'Bijvoorbeeld: A',

	'textFilterAndButton': 'En',
	'textFilterOrButton': 'Of',

	'dateFilterMessage': 'Selecteer een datumbereik',
	'dateRangeControlRegionLabel': 'Filter datumbereik - %{columnName}',
	'dateFilterRangeOption': 'Optie voor bereik',
	'dateFilterDateLabel': 'Date',
	'dateFilterBlank': '(blanco)',
	'dateFilterBefore': 'Vóór',
	'dateFilterAfter': 'Na',
	'dateFilterBetween': 'Tussen',
	'dateFilterSampleText': 'DD-MM-YYYY',
	'dateTitle': 'Date',
	'dateIncludeBlankLabel': 'Lege datum gebruiken',

	'timeTitle': 'Tijd',
	'timeFilterMessage': 'Een tijdbereik selecteren',
	'dateTimeFilterMessage': 'Een datum- en tijdbereik selecteren',

	'topbottomNumberOfResultsLabel': 'Aantal resultaten',
	'topbottomPercentLabel': 'Percentage',
	'topbottomNumberOfResultsLimit': 'Tussen %{lower}-%{higher}',
	'topbottomSelectOption': 'Optie voor hoogste of laagste',
	'topbottomOptionLabel': 'Weergeven',
	'searchByLabel': 'Op',
	'searchNoMatches': 'Geen overeenkomsten gevonden',
	'topbottomRankColumnLabel': 'Een kolom voor rangorde toevoegen aan de tabel',
	'topbottomNone': 'Geen',
	'topCount': 'Hoogste aantal',
	'topPercent': 'Bovenste %',
	'bottomCount': 'Laagste aantal',
	'bottomPercent': 'Onderste %',
	'topbottomSearchColumn': 'Een kolom zoeken',
	'searchColumnAriaLabel': 'Een kolom zoeken. Typ de naam van de kolom om te zoeken en gebruik vervolgens de pijl omlaag om de kolom in een lijst op te zoeken',
	'rankColumnLabel': 'Rang (%{columnLabel})',
	'topbottomClearLabel': 'Verwijderen',

	'rangeFilterControlRegionLabel': 'Bereikfilter - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Schuifregelaar - met de rechter en linker cursortoetsen verplaatst u de handvatten van de schuifregelaar',
	'sliderHandleLabel': 'Handvat van schuifregelaar',
	'a11ySliderHandleLabel': 'Hendel schuifregelaar %{sliderValue}',
	'sliderInputLabel': 'waarde',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Sommige gegevensset-items die in deze visualisatie worden gebruikt, zijn niet beschikbaar.',
	'datasetItemUnavailable': 'Dit item van de gegevensset is niet beschikbaar.',

	//Authoring topBottom
	'topOperator': 'Bovenaan',
	'bottomOperator': 'Onderaan',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} per %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Alleen dit object',
	'deleteTopBottom': 'Telling voor hoogste of laagste wissen',
	'editTopBottom': 'Telling voor hoogste of laagste bewerken',
	'deleteDrillState': 'De huidige drillstatus wissen',
	'ariaDeleteDrillStateLabel': 'Druk op ENTER om de telling voor hoogste of laagste te bewerken.',
	'drillUpStateTitle': 'Omhoog drillen',
	'drillDownStateTitle': 'Omlaag drillen',
	'ariaEditTopBottomLabel': 'Druk op ENTER om de telling voor hoogste of laagste te bewerken.',
	'ariaDeleteTopBottomLabel': 'Druk op DELETE om de telling voor hoogste of laagste te wissen.',

	// Authoring filtering
	'dimFilterIn': 'Bevat: %{in}',
	'dimFilterNotIn': 'Bevat niet: %{out}',
	'measureFilterBetween': 'Tussen %{lowerBound} en %{upperBound}',
	'measureFilterNotBetween': 'Niet tussen %{lowerBound} en %{upperBound}',
	'gtFilter': 'Na %{lowerBound}',
	'ltFilter': 'Voor %{upperBound}',
	'notGtFilter': 'Niet na %{lowerBound}',
	'notLtFilter': 'Niet voor %{upperBound}',
	'localFilterTitle': 'Alleen dit object',
	'globalFilterTitle': 'Alle objecten',
	'deleteFilter': 'Filter wissen',
	'editFilter': 'Filter bewerken',
	'ariaEditFilterLabel': 'Druk op ENTER om de filter te bewerken.',
	'ariaDeleteFilterLabel': 'Druk op DELETE om de filter te wissen.',

	// Prompts
	'ariaEditPrompt': 'Druk op ENTER om de promptwaarde te wijzigen',

	'moreDataIndicator': 'Uw gegevens zijn afgekapt bij %{threshold} items. Pas een filter toe om minder af te beelden.',

	// data point filtering
	'dataPointFilterTitle': 'Gegevenspunten',
	'dataPointFilterIncludeSummary': 'Inbegrepen %{valueCount} gegevenspunten',
	'dataPointFilterExcludeSummary': 'Uitgesloten %{valueCount} gegevenspunten',

	// DB2 connection page
	'db2Database': 'DB2-database (%{jdbcConnection})',
	'db2Title': 'Verbinding maken met IBM DB2',

	// Database
	'databaseConnectionMessage': 'Geef de verbindingsgegevens voor uw database op:',
	'connectionString': 'Verbindingsreeks database',
	'databaseCredentials': 'Legitimatiegegevens: ',
	'databaseUserName': 'Gebruikersnaam',
	'databasePassword': 'Wachtwoord',
	'databaseConnect': 'Verbinding maken',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Geef een zoekterm op:',
	'twitterKeyword': 'Trefwoord',
	'twitterSearch': 'Zoeken',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'De view %{error} kan niet gemaakt worden\nMislukte bewerking: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Widgetfilters',
	'missingColumn': 'Ontbrekend: %{columnLabel}',
	'missingFiltering': 'Er ontbreken filters voor de volgende kolom-ID\'s:',
	'heatByLabel': 'Heat op basis van',
	'evColumns': 'Kolommen',
	'evLocalFilters': 'Lokale filters',
	'evExpand': 'Uitvouwen',
	'evFilterTooltip': 'Filteren',
	'evAdd': 'Kolom toevoegen',

	// Navigation View
	'navigationBack': 'Terug',

	// Pinning
	'contentPinFail': 'De inhoud kan niet verzameld worden. Probeer het later opnieuw.',
	'contentPinFailOld': 'De inhoud kan niet vastgezet worden. Probeer het later opnieuw.',
	'pinRenameFail': 'We kunnen de pin niet hernoemen. Probeer het later nog eens.',

	// Layouts
	'dropZoneLabel': 'Hier neerzetten om te maximaliseren',

	//Share
	'shareDefaultPageTitle': 'Pagina %{index}',

	'nextPage': 'Volgende pagina',
	'previousPage': 'Vorige pagina',

	'assetAssembly': 'view',

	'toolbar_save': 'Opslaan',
	'brgr_saveAs': 'Opslaan als',
	'brgr_refresh': 'Vernieuwen',

	// Save
	'saving': 'Opslaan...',
	'save_success': 'Uw view is opgeslagen.',
	'save_failure': 'Sorry. Uw view kan niet worden opgeslagen. Probeer het later opnieuw.',
	'dashboard_save_success': 'Uw dashboard is opgeslagen.',

	'geminiLeave': 'U staat op het punt om IBM Watson Analytics te verlaten.',

	'warning': 'Waarschuwing',
	'missingDataSetData': 'De gegevens voor deze gegevensset zijn niet beschikbaar. Vernieuw de gegevensset of vraag de beheerder om toegang tot de bron.',

	// Calculations
	'error_calculation_in_use': 'De geselecteerde berekening is in gebruik en kan niet gewist worden.',

	'resize': 'Formaat wijzigen',
	'rotate': 'Draaien',
	'moveHandle': 'Widget verplaatsen',
	'expandHandle': 'Uitvouwen',
	'panHandle': 'Horizontaal verschuiven',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Navigeren naar',

	// Slide out titles
	'shapeSlideoutTitle': 'Vormen',
	'textSlideoutTitle': 'Tekst',
	'mediaSlideoutTitle': 'Media',
	'visualizationSlideoutTitle': 'Visualisaties',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'De opgegeven JSON is ongeldig. Raadpleeg het foutenlogboek voor meer informatie.',

	// Widget type labels
	'shape_label': 'Vorm',
	'image_label': 'Afbeelding',
	'data_label': 'Diagram',
	'media_label': 'Media',
	'text_label': 'Tekst',
	'embedMedia_label': 'Media',
	'youtube_label': 'YouTube-video',
	'webpage_label': 'Webpagina',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Vorm',
	'noExtraText_shape_numbered': 'Vorm (%{number})',
	'few_shape': 'Groep van %{count} vormen',
	'many_shape': 'Groep van %{count} vormen',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text}-afbeelding',
	'one_image_numbered': '%{text}-afbeelding (%{number})',
	'noExtraText_image': 'Afbeelding',
	'noExtraText_image_numbered': 'Afbeelding (%{number})',
	'few_image': 'Groep van %{count} afbeeldingen',
	'many_image': 'Groep van %{count} afbeeldingen',
	'noExtraText_text': 'Leeg tekstvak',
	'noExtraText_text_numbered': 'Leeg tekstvak (%{number})',
	'few_text': 'Groep van %{count} tekstvakken',
	'many_text': 'Groep van %{count} tekstvakken',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Kubusviewer',
	'pacubeviewer_named': '%{name}-kubusviewer',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{values} per %{row_level1} en %{column_level1} kruistabel',
	'crosstab_opt_mapping_numbered': '%{values} per %{row_level1} en %{column_level1} (%{number}) kruistabel',
	'crosstab_has_mapping': '%{values} per %{row_level1} kruistabel',
	'crosstab_has_mapping_numbered': '%{values} per %{row_level1} (%{number}) kruistabel',
	'crosstab_no_mapping': 'Lege kruistabel',
	'crosstab_no_mapping_numbered': 'Lege kruistabel (%{number})',
	'crosstab_named': '%{name} kruistabel',
	'crosstab_named_numbered': '%{name} kruistabel (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} tabel',
	'JQGrid_has_mapping_numbered': '%{grid_cols} tabel  (%{number})',
	'JQGrid_no_mapping': 'Lege tabel',
	'JQGrid_no_mapping_numbered': 'Lege tabel (%{number})',
	'JQGrid_named': '%{name} tabel',
	'JQGrid_named_numbered': '%{name} tabel (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} hiërarchie',
	'hierarchy_has_mapping_numbered': '%{level1} hiërarchie (%{number})',
	'hierarchy_no_mapping': 'Lege hiërarchie',
	'hierarchy_no_mapping_numbered': 'Lege hiërarchie (%{number})',
	'hierarchy_named': '%{name} hiërarchie',
	'hierarchy_named_numbered': '%{name} hiërarchie (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} kaart',
	'map_has_mapping_numbered': '%{categories} kaart (%{number})',
	'map_no_mapping': 'Lege kaart',
	'map_no_mapping_numbered': 'Lege kaart (%{number})',
	'map_named': '%{name} kaart',
	'map_named_numbered': '%{name} kaart (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} samenvattingswaarde',
	'summary_has_mapping_numbered': '%{actual} samenvattingswaarde (%{number})',
	'summary_no_mapping': 'Lege samenvattingswaarde',
	'summary_no_mapping_numbered': 'Lege samenvattingswaarde (%{number})',
	'summary_named': '%{name} samenvattingswaarde',
	'summary_named_numbered': '%{name} samenvattingswaarde (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual} per %{sparkline.time} KPI',
	'kpi_opt_mapping_numbered': '%{actual} per %{sparkline.time} KPI (%{number})',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI (%{number})',
	'kpi_no_mapping': 'Lege KPI',
	'kpi_no_mapping_numbered': 'Lege KPI (%{number})',
	'kpi_named': '%{name} KPI',
	'kpi_named_numbered': '%{name} KPI (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} infographic',
	'infographicSummary_has_mapping_numbered': '%{actual} infographic (%{number})',
	'infographicSummary_no_mapping': 'Lege infographic',
	'infographicSummary_no_mapping_numbered': 'Lege infographic (%{number})',
	'infographicSummary_named': '%{name} infographic',
	'infographicSummary_named_numbered': '%{name} infographic (%{number})',
	'noExtraText_youtube': 'YouTube-video',
	'noExtraText_youtube_numbered': 'YouTube-video (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} YouTube-video',
	'one_youtube_numbered': '%{text} YouTube-video (%{number})',
	'few_youtube': 'Groep van %{count} YouTube-video\'s',
	'many_youtube': 'Groep van %{count} YouTube-video\'s',
	'noExtraText_embedMedia': 'Medialink',
	'noExtraText_embedMedia_numbered': 'Medialink (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} medialink',
	'one_embedMedia_numbered': '%{text} medialink (%{number})',
	'few_embedMedia': 'Groep van %{count} medialinks',
	'many_embedMedia': 'Groep van %{count} medialinks',
	'noExtraText_media': 'Media',
	'noExtraText_media_numbered': 'Media (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} media',
	'one_media_numbered': '%{text} media (%{number})',
	'few_media': 'Groep van %{count} media',
	'many_media': 'Groep van %{count} media',
	'noExtraText_webpage': 'Webpagina',
	'noExtraText_webpage_numbered': 'Webpagina (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} webpagina',
	'one_webpage_numbered': '%{text} webpagina (%{number})',
	'few_webpage': 'Groep van %{count} webpagina\'s',
	'many_webpage': 'Groep van %{count} webpagina\'s',
	'one_unknown': 'Een object',
	'one_unknown_numbered': 'Een object (%{number})',
	'few_unknown': 'Groep van %{count} objecten',
	'many_unknown': 'Groep van %{count} objecten',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Volgende',
	'previous': 'Vorige',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'De huidige navigatiegroep is%{navigation_group_name}',

	//Page Context
	'filterBlank': '(blanco)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Filterwaarden kunnen niet geladen worden',
	'editTimelineHighlight': 'Accentuering bewerken',

	'filterDockChevronLeft': 'Scrollen door de gegevens',
	'filterDockChevronRight': 'Scrollen door de gegevens',
	'expand': 'Uitvouwen',
	'collapse': 'Samenvouwen',

	//Reset Dashboard
	'dashboardResetTitle': 'Dashboard resetten',
	'dashboardResetMessage': 'Weet u zeker dat u alle wijzigingen die op dit dashboard toegepast zijn, wilt verwijderen?',
	'dashboardResetToast': 'Uw dashboard is gereset.',

	//Generate PDF
	'buildingPDF': 'PDF bouwen...',
	'exportPDF': 'Exporteren naar PDF',
	'pageSize': 'Paginagrootte',
	'orientation': 'Afdruk',
	'filtersPresentPDF': 'Filter(s) toegepast op de visualisatie(s) op de vorige pagina:',
	'errorPDF': 'PDF kan niet gegenereerd worden. Vernieuw en probeer het opnieuw.',
	'errorPrintPDF': 'PDF kan niet gegenereerd worden. Probeer het opnieuw.',
	'printPDFInfo': 'Documentatie bekijken',
	'pdfWidget': 'Widget',
	'includeFilters': 'Filterdetails afbeelden',
	'portrait': 'Staand',
	'landscape': 'Liggend',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Uw dashboard is geüpgraded. Sla nu op om optimale prestaties te handhaven.',

	'migratingDashboard': 'Uw dashboardgegevens moeten worden gemigreerd, dashboard wordt opgeslagen als de migratie voltooid is ...',
	'migrateDone': 'Uw dashboardgegevens zijn gemigreerd.',
	'migrateNoPermission': 'Uw dashboardgegevens moeten worden gemigreerd; hiervoor is schrijfmachtiging vereist; visualisaties worden weergegeven met een fout.',
	'migratingDataSourcesFailed': 'een of meer gegevensbronnen mislukte gegevensmigratie',

	'ariaFullScreenMessage': 'Druk op Escape om het volledige scherm te verlaten',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} gecomprimeerd hiërarchisch bellendiagram',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} gecomprimeerd hiërarchisch bellendiagram (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Leeg gecomprimeerd hiërarchisch bellendiagram',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Leeg gecomprimeerd hiërarchisch bellendiagram (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} gecomprimeerd hiërarchisch bellendiagram',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} gecomprimeerd hiërarchisch bellendiagram (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{categories} per %{values} Marimekkodiagram',
	'LIVE_marimekko_has_mapping_numbered': '%{categories} per %{values} Marimekko-diagram (%{number})',
	'LIVE_marimekko_no_mapping': 'Leeg Marimekko-diagram',
	'LIVE_marimekko_no_mapping_numbered': 'Leeg Marimekko-diagram (%{number})',
	'LIVE_marimekko_named': '%{name} Marimekko-diagram',
	'LIVE_marimekko_numbered': '%{name} Marimekko-diagram (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} zonnestraaldiagram',
	'LIVE_sunburst_has_mapping_numbered': '%{values} zonnestraaldiagram (%{number})',
	'LIVE_sunburst_no_mapping': 'Leeg zonnestraaldiagram',
	'LIVE_sunburst_no_mapping_numbered': 'Leeg zonnestraaldiagram (%{number})',
	'LIVE_sunburst_named': '%{name} zonnestraaldiagram',
	'LIVE_sunburst_named_numbered': '%{name} zonnestraaldiagram (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values} driveranalysediagram',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} driveranalysediagram (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Leeg driveranalysediagram',
	'LIVE_decision_analysis_no_mapping_numbered': 'Leeg driveranalysediagram (%{number})',
	'LIVE_decision_analysis_named': '%{name} driveranalysediagram',
	'LIVE_decision_analysis_named_numbered': '%{name} driveranalysediagram (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{categories} per %{columnValue} en %{lineValue} lijn- en kolomdiagram',
	'LIVE_line_column_opt_mapping_numbered': '%{categories} per %{columnValue} en %{lineValue} lijn- en kolomdiagram (%{number})',
	'LIVE_line_column_has_mapping': '%{columnValue} en %{lineValue} lijn- en kolomdiagram',
	'LIVE_line_column_has_mapping_numbered': '%{categories} per %{columnValue} en %{lineValue} lijn- en kolomdiagram (%{number})',
	'LIVE_line_column_no_mapping': 'Leeg lijn- en kolomdiagram',
	'LIVE_line_column_no_mapping_numbered': 'Leeg lijn-en kolomdiagram (%{number})',
	'LIVE_line_column_named': '%{name} lijn- en kolomdiagram',
	'LIVE_line_column_named_numbered' : '%{name} lijn- en kolomdiagram (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{x} per %{y} en %{size} bellendiagram',
	'LIVE_bubble_chart_has_mapping_numbered': '%{x} per %{y} en %{size} bellendiagram (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Leeg bellendiagram',
	'LIVE_bubble_chart_no_mapping_numbered': 'Leeg bellendiagram (%{number})',
	'LIVE_bubble_chart_named': '%{name} bellendiagram',
	'LIVE_bubble_chart_named_numbered': '%{name} bellendiagram (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual} bulletdiagram',
	'LIVE_bullet_has_mapping_numbered': '%{actual} bulletdiagram (%{number})',
	'LIVE_bullet_no_mapping': 'Leeg bulletdiagram',
	'LIVE_bullet_no_mapping_numbered': 'Leeg bulletdiagram (%{number})',
	'LIVE_bullet_named': '%{name} bulletdiagram',
	'LIVE_bullet_named_numbered': '%{name} bulletdiagram (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'Gegevens op dit dashboard worden verstrekt door',
	'showFooterToggleButtonText': 'Voettekst afbeelden',
	'showFooterSectionText': 'Voettekst'

});
